export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Schrijf een bericht...',
  blogsFeedSearchInputPlaceholder: 'Zoeken',
  blogsFeedPostOwnerCurtainEditTitle: 'Bericht bewerken',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Bericht verwijderen',
  blogsFeedEditedPostSavedAlertText: 'Bericht opgeslagen!',
  blogsFeedEditedPostDeletedAlertText: 'Bericht verwijderd!',
  blogsFeedShareCurtainOptionTitle: 'Kopieer link',
  blogsFeedPostLinkCopiedAlertText: 'Link gekopieerd!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Kopieer link',
  blogsFeedOthersPosLinkCopiedAlertText: 'Link gekopieerd!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Rapporteer inhoud',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Bericht verwijderen',
  blogsFeedPostDeletePopupTitle: 'Verwijderen',
  blogsFeedPostDeletePopupText: 'Dit bericht verwijderen?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Annuleren',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Bevestigen',
  blogsFeedPostDeeletedAlertText: 'Bericht verwijderd!',
  blogsPostDetailsHeaderTitle: 'Bericht',
  postFeedPostLikesText: 'Likes',
  postFeedPostCommentsText: 'Reacties',
  postFeedPostNoLikesText: 'Er zijn nog geen likes',
  postFeedPostLeaveFirstLikeText: 'U kunt als eerste liken',
  blogsFeedPostDetailsNoCommentsText: 'Er zijn nog geen reacties',
  blogsFeedPostDetailsFirstCommentText: 'U kunt als eerste reageren',
  blogsFeedPostDetailsShareOptionTitle: 'Kopieer link',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Link gekopieerd!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Kopieer link',
  blogsFeedPostDetailsCopiedAlertText: 'Link gekopieerd!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Rapporteer inhoud',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Rapporteer',
  blogsPostDetailsReportedCurtainText: 'Inhoud gerapporteerd',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Reactie bewerken',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Reactie verwijderen',
  blogsPostDetailsEditedCommentSavedAlertText: 'Reactie opgeslagen!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Reactie verwijderen',
  postDetailsOtherUsersCommentDeletadAlertText: 'Reactie verwijderd!',
  postDetailsDeleteCommentPopupTitle: 'Verwijderen',
  postDetailsDeleteCommentPopupText: 'Deze reactie verwijderen?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Annuleren',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bevestigen',
  postDetailsCommDeletedAlertText: 'Reactie verwijderd!',
  postDetailsCommentUserCurtainOptionTitle: 'Rapporteer reactie',
  blogsCreatePostCurtainTitle: 'Nieuw bericht',
  blogsCreatePostCurtainBodyPlaceholder: 'Plaats hier uw tekst...',
  blogsCreatePostPublishButtonTitle: 'Publiceren',
  blogsCreatePostUploadSlallerImageAlertText: 'U kunt maximaal {size} MB tegelijk uploaden',
  blogsPostSavedAlertText: 'Bericht opgeslagen!',
  blogsCreatePostAddLocationCurtainTitle: 'Locatie',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Locatienaam',
  blogsCreatePostEditLocationCurtainText: 'Locatie bewerken',
  blogsDeleteLocation: 'Locatie verwijderen',
  blogsDiscardPostPopupTitle: 'Concept',
  blogsDiscardPostPopupText: 'Dit concept verwijderen?',
  blogsDiscardPostPopupCancelButtonTitle: 'Annuleren',
  blogsDiscardPostPopupCofirmButtonTitle: 'Bevestigen',
  blogsNewPostCreatePollTitle: 'Poll maken',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Titel',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Optie',
  blogsNewPostCreatePollAddButtonTitle: 'Optie toevoegen',
  blogsNewPostCreatePollCreateButtonTitle: 'Maken',
  blogsCreatePostPollTitleBlankAlertText: 'Titel kan niet leeg zijn!',
  blogsCreatePostPollOptionBlankAlertText: 'Optie kan niet leeg zijn!',
  blogsCreatePostPollLongTitleAlertText: 'Titel mag maximaal {length} tekens bevatten',
  blogsCreatePostPollLongOptionAlertText: 'Optie mag maximaal {length} tekens bevatten',
  blogsCreatePostPollEditOptionTitle: 'Poll bewerken',
  blogsCreatePostPollRemoveOptionTitle: 'Poll verwijderen',
  blogsPostPollInfoVotesText: 'stemmen',
  blogsPostPollInfoEditVoteText: 'Stem bewerken',
  blogsPostPollFinishPollText: 'Poll afronden',
  blogsPostPollFinishedPollText: 'Afgelopen',
  blogsPostPollInProgresslText: 'Bezig',
  blogsFinishPollCurtainTitle: 'Poll afronden',
  blogsFinishPollCurtainText: 'Gebruikers kunnen niet meer stemmen nadat de poll is afgerond.',
  blogsFinishPollCurtainCancelButtonTitle: 'Annuleren',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Bevestigen',
  blogsPollInfoPollVotesCurtainTitle: 'Poll stemmen',
  blogsEditPostCurtainTitle: 'Bericht bewerken',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Plaats hier uw tekst...',
  blogsEditPostCurtainSaveButtonTitle: 'Opslaan',
  blogsEditPostSavedAlertText: 'Bericht opgeslagen!',
  blogsError: 'Er is iets misgegaan!',
  blogsAt: 'op',
  blogsSeeMore: 'Bekijk meer...',
  blogsMaxAttachments: 'U heeft het maximale aantal bijlagen overschreden. Maximaal aantal bijlagen is {length}',
  blogsReply: 'Antwoorden',
  blogsAddCover: 'Cover toevoegen'
}
